import ControleSessao from "../../componentes-padrao/ControleSessao";
import { logout } from "./api";

export const getURIRedirect = () => {
    const uri = window.location.href;

    return uri.replace(/\/$/, "");
};

/**
 * Ação do botão "Sair" do ePonto (JOR4-7237).
 *
 * Para usuários com vínculo de transportador externo, "Sair" espelha o "Sair" do
 * painel do transportador: volta à tela de seleção de plataforma SEM encerrar a
 * sessão no Keycloak. Basta recarregar a aplicação — sem os parâmetros de código
 * de autorização na URL, o boot (index.js) reencaminha ao Keycloak, que, com a
 * sessão SSO ainda ativa, devolve um novo código sem pedir credenciais e a tela
 * de seleção (SelecionaTipoAcesso) reaparece. O logout de fato fica a cargo do
 * "Sair" daquela tela.
 *
 * Sem esse vínculo não há tela de seleção para onde voltar (o boot entra direto
 * no ePonto), então mantemos o logout completo no Keycloak — do contrário o
 * usuário ficaria preso, reentrando no ePonto sem conseguir deslogar.
 */
export const sairDoEponto = () => {
    if (ControleSessao.getPossuiVinculoTransportadorExterno()) {
        window.location.reload();
        return;
    }

    const refreshToken = ControleSessao.getRefreshToken();
    logout(refreshToken)
        .then(() => window.location.reload())
        .catch((err) => console.log(err));
};
